var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersLogoTotsl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 13C9.11866 13 10.9375 11.1812 10.9375 8.9375C10.9375 6.69384 9.11866 4.875 6.875 4.875C4.63134 4.875 2.8125 6.69384 2.8125 8.9375C2.8125 11.1812 4.63134 13 6.875 13Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3074 5.02344C11.6665 4.92604 12.0368 4.87613 12.4089 4.875C13.4864 4.875 14.5197 5.30301 15.2816 6.06488C16.0434 6.82675 16.4714 7.86006 16.4714 8.9375C16.4714 10.0149 16.0434 11.0483 15.2816 11.8101C14.5197 12.572 13.4864 13 12.4089 13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.9218C1.88433 15.0192 2.72659 14.2824 3.70563 13.7738C4.68467 13.2652 5.77173 12.9997 6.875 12.9997C7.97827 12.9997 9.06533 13.2652 10.0444 13.7738C11.0234 14.2824 11.8657 15.0192 12.5 15.9218",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4089 13C13.5123 12.9993 14.5996 13.2645 15.5787 13.7731C16.5579 14.2817 17.4 15.0188 18.0339 15.9219",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLogoTotsl);
export default __webpack_public_path__ + "static/media/usersLogoTotsl.ea53abc4f3940950ecff7b907b489fcf.svg";
export { ForwardRef as ReactComponent };